// extracted by mini-css-extract-plugin
export default {"text":"images_text__Tjgue","logosGrid":"images_logosGrid__D+-H8","logoBox":"images_logoBox__LqOBD","logo":"images_logo__Zs3JS"};